import React, {useEffect, useState} from 'react'
import {ReactComponent as Logoh} from "../svgs/pickpic_logo_horizontal.svg";
import {ReactComponent as Logov} from "../svgs/pickpic_logo.svg";

export const AboutPage = () => {
    return (
        <div className="AboutPage">
            <div className="headerHolder">
                pickpic<i style={{"fontSize":"50%"}}>beta</i>
            </div>
            <div className="aboutInfoHolder">
                <div className="aboutBlock">
                    <h2>Pickpic — бот для автоматизации отбора фотографий.</h2>
                    <p>Благодаря нам Вы сможете экономить большое количество времени, которое уходит на поиск нужных фотографий.</p>
                </div>
                <div className="aboutBlock">Цены</div>
                <div className="aboutBlock">Видос</div>
            </div>
        </div>
    )
}